import { TBase36Id } from 'types';
import { TableColumnsType, TableProps } from 'antd';
import { format } from 'date-fns';
import { IGetJobApplies } from '../types';
import { FiltersWrapper, FilterTypesEnum } from 'components';
import HandleBoolean from 'utils/handleBoolean';
import StatusCard from 'components/ui/StatusCard/StatusCard';
import { DownloadOutlined } from '@ant-design/icons';
import { store } from 'store/store.ts';
import { globalApi } from '../../../api';
const dispatch = store.dispatch;

export const jobsAppliesApiRoutes = {
  JOB_APPLIES: 'v1/job-applicants',
  JOB_APPLIES_BY_ID: (id: TBase36Id) => `v1/job-applicants/${id}`,
  JOB_CHANGE_STATUS: (id: TBase36Id) => `v1/job-applicants/email/${id}`,
};

export enum JobAppliesModalEnum {
  VIEW = 'View',
}

export enum JobAppliesEnum {
  Applied = 0,
  'Under_Review' = 1,
  Screening = 2,
  Shortlisted = 3,
  'Phone_Interview' = 4,
  'HR_Interview' = 5,
  'Technical_Interview' = 6,
  Test_Assignment = 7,
  'Final_Interview' = 8,
  Offer = 9,
  Hired = 10,
  'Offer_Declined' = 11,
  Rejected = 12,
}

export const JOB_APPLIES_LIST = {
  Applied: JobAppliesEnum.Applied,
  Under_Review: JobAppliesEnum.Under_Review,
  Screening: JobAppliesEnum.Screening,
  Shortlisted: JobAppliesEnum.Shortlisted,
  Phone_Interview: JobAppliesEnum.Phone_Interview,
  HR_Interview: JobAppliesEnum.HR_Interview,
  Technical_Interview: JobAppliesEnum.Technical_Interview,
  Test_Assignment: JobAppliesEnum.Test_Assignment,
  Final_Interview: JobAppliesEnum.Final_Interview,
  Offer: JobAppliesEnum.Offer,
  Hired: JobAppliesEnum.Hired,
  Offer_Declined: JobAppliesEnum.Offer_Declined,
  Rejected: JobAppliesEnum.Rejected,
};

export enum JobAppliesModalEnum {
  Reject = 0,
  Review = 1,
}

export const jobAppliesTableColumns: TableColumnsType<IGetJobApplies> = [
  {
    title: 'ID',
    width: 100,
    dataIndex: 'id',
    key: 'id',
    align: 'center',
    sorter: true,
    render: (value) => {
      return (
        <div title={value} style={{ color: '#4E37D3' }}>
          {value}
        </div>
      );
    },
    filterDropdown: ({ close }) => {
      return (
        <FiltersWrapper
          type={FilterTypesEnum.BASE_36_ID}
          name={'ID'}
          endpointPath={'job-applicants'}
          propertyName={'Id'}
          onClose={close}
        />
      );
    },
  },
  {
    title: 'Creation Date',
    width: 150,
    dataIndex: 'createdAt',
    key: 'createdAt',
    align: 'center',
    sorter: true,
    render: (value) => {
      return (
        <div title={String(format(value, 'dd/MM/yyyy hh:mm'))}>
          {format(value, 'dd/MM/yyyy hh:mm')}
        </div>
      );
    },
    filterDropdown: ({ close }) => {
      return (
        <FiltersWrapper
          type={FilterTypesEnum.DATE}
          name={'CreatedAt'}
          endpointPath={'job-applicants'}
          propertyName={'CreatedAt'}
          onClose={close}
        />
      );
    },
  },
  {
    title: 'First name',
    width: 150,
    dataIndex: 'firstName',
    key: 'FirstName',
    align: 'center',
    sorter: true,
    filterDropdown: ({ close }) => {
      return (
        <FiltersWrapper
          type={FilterTypesEnum.TEXT}
          name={'FirstName'}
          endpointPath={'job-applicants'}
          propertyName={'FirstName'}
          onClose={close}
        />
      );
    },
  },
  {
    title: 'Last Name',
    width: 150,
    dataIndex: 'lastName',
    key: 'LastName',
    align: 'center',
    sorter: true,
    filterDropdown: ({ close }) => {
      return (
        <FiltersWrapper
          type={FilterTypesEnum.TEXT}
          name={'LastName'}
          endpointPath={'job-applicants'}
          propertyName={'LastName'}
          onClose={close}
        />
      );
    },
  },
  {
    title: 'Email Address',
    width: 150,
    dataIndex: 'email',
    key: 'Email',
    align: 'center',
    sorter: true,
    filterDropdown: ({ close }) => {
      return (
        <FiltersWrapper
          type={FilterTypesEnum.TEXT}
          name={'Email'}
          endpointPath={'job-applicants'}
          propertyName={'Email'}
          onClose={close}
        />
      );
    },
  },
  {
    title: 'Cover Letter',
    width: 150,
    dataIndex: 'coverLetter',
    key: 'CoverLetter',
    align: 'center',
    sorter: true,
    filterDropdown: ({ close }) => {
      return (
        <FiltersWrapper
          type={FilterTypesEnum.BASE_36_ID}
          name={'CoverLetter'}
          endpointPath={'job-applicants'}
          propertyName={'CoverLetter'}
          onClose={close}
        />
      );
    },
  },
  {
    title: 'Minimum Salary',
    width: 180,
    dataIndex: 'minSalary',
    key: 'MinSalary',
    align: 'center',
    sorter: true,
    filterDropdown: ({ close }) => {
      return (
        <FiltersWrapper
          type={FilterTypesEnum.TEXT}
          name={'MinSalary'}
          endpointPath={'job-applicants'}
          propertyName={'MinSalary'}
          onClose={close}
        />
      );
    },
  },
  {
    title: 'Phone Number',
    width: 150,
    dataIndex: 'phoneNumber',
    key: 'PhoneNumber',
    align: 'center',
    sorter: true,
    filterDropdown: ({ close }) => {
      return (
        <FiltersWrapper
          type={FilterTypesEnum.TEXT}
          name={'PhoneNumber'}
          endpointPath={'job-applicants'}
          propertyName={'PhoneNumber'}
          onClose={close}
        />
      );
    },
  },
  {
    title: 'Status',
    width: 150,
    dataIndex: 'status',
    key: 'Status',
    align: 'center',
    sorter: true,
    render(value) {
      return (
        <div
          title={String(JobAppliesEnum[value as keyof typeof JobAppliesEnum])}
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          <StatusCard status={value} text={JobAppliesEnum[value as keyof typeof JobAppliesEnum]} />
        </div>
      );
    },
    filterDropdown: ({ close }) => {
      return (
        <FiltersWrapper
          type={FilterTypesEnum.TAGS}
          name={'Status'}
          propertyName={'Status'}
          onClose={close}
          options={Object.keys(JOB_APPLIES_LIST).map((el) => ({
            label: el,
            value: JOB_APPLIES_LIST[el as keyof typeof JOB_APPLIES_LIST],
          }))}
        />
      );
    },
  },
  {
    title: 'Reject Email Sent',
    width: 150,
    dataIndex: 'rejectEmailSent',
    key: 'RejectEmailSent',
    align: 'center',
    sorter: true,
    render(value) {
      return <HandleBoolean value={value} trueText={'Yes'} falseText={'No'} />;
    },
    filterDropdown: ({ close }) => {
      return (
        <FiltersWrapper
          type={FilterTypesEnum.BOOLEAN}
          name={'RejectEmailSent'}
          endpointPath={'job-applicants'}
          propertyName={'RejectEmailSent'}
          onClose={close}
          options={[
            { label: 'Yes', value: 'true' },
            { label: 'No', value: 'false' },
          ]}
        />
      );
    },
  },
  {
    title: 'Title',
    width: 150,
    dataIndex: 'title',
    key: 'Title',
    align: 'center',
    sorter: true,
    filterDropdown: ({ close }) => {
      return (
        <FiltersWrapper
          type={FilterTypesEnum.TEXT}
          name={'Title'}
          endpointPath={'job-applicants'}
          propertyName={'Title'}
          onClose={close}
        />
      );
    },
  },
  {
    title: 'CV file',
    width: 150,
    dataIndex: 'cvFileId',
    key: 'CvUrl',
    align: 'center',
    render: (value) => {
      return (
        <a
          title={''}
          style={{ display: 'flex', gap: 8, alignItems: 'center' }}
          rel="noreferrer"
          role={'button'}
          onClick={(e) => {
            e.stopPropagation();
            dispatch(globalApi.endpoints.downloadFile.initiate(value) as any);
          }}
        >
          <DownloadOutlined />
          Download CV
        </a>
      );
    },
  },
];

export const jobAppliesTableStructure: TableProps = {
  bordered: true,
  size: 'small',
  scroll: {
    y: 500,
    x: 800,
    scrollToFirstRowOnChange: true,
  },
};
